import {Box, Flex, HStack, Text} from "@chakra-ui/react";
import React, {useState} from "react";
import {ReactComponent as TelegramIcon} from "../../../assets/icons/telegramIcon.svg";
import {ReactComponent as EmailIcon} from "../../../assets/icons/emailIcon.svg";
import {ReactComponent as LockIcon} from "../../../assets/icons/lock.svg";
import {CustomCheckbox, CustomSelectCountries, InputLabel, StyledButton} from "../../index";
import {ReactComponent as EyeIcon} from "../../../assets/icons/eye-closed.svg";
import {ReactComponent as CopyIcon} from "../../../assets/icons/copy-alt.svg";
import {ReactComponent as BadgeIcon} from "../../../assets/icons/badge-discount-alt.svg";
import {useForm} from "react-hook-form";
import {Link} from "react-router-dom";

export const RegisterForm = ({isMobile}) => {
    const [showPassword, setShowPassword] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState('');

    const {
        register,
        handleSubmit,
        getValues,
        watch,
        formState: {errors, isValid, isDirty}
    } = useForm({
        mode: "onTouched",
        defaultValues: {
            email: '',
            phone: '',
            telegram: '',
            password: '',
            repeatPassword: '',
            promocode: '',
        }
    })
    const password = watch('password')

    const submit = (e) => {
        console.log(e)
    }

    const togglePassword = () => {
        setShowPassword((prev) => !prev);
    }

    const copyPromocode = () => {
        navigator.clipboard.writeText(getValues('promocode'))
    }

    return (
        <form onSubmit={handleSubmit(submit)}>
            <Flex
                direction={'column'}
                gap={isMobile ? '20px' : '24px'}>
                <InputLabel
                    label={'Email'}
                    height={isMobile ? '40px' : '52px'}
                    fontSize={isMobile ? '14px' : '18px'}
                    isInvalid={!!errors.email}
                    errormessage={!!errors.email && errors.email.message}
                    {...register('email', {
                        required: 'Email is required',
                        pattern: {
                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                            message: "Invalid email address",
                        },
                    })}
                    placeholder={'Email or Phone number'}
                    maxW={'565px'}
                    leftAddon={<EmailIcon width={isMobile ? '20px' : '26px'}/>}/>
                <HStack maxW={'565px'}>
                    <CustomSelectCountries
                        isMobile={isMobile}
                        selectedCountry={selectedCountry}
                        setSelectedCountry={setSelectedCountry}/>
                    <InputLabel
                        label={'Phone'}
                        height={isMobile ? '40px' : '52px'}
                        type={'number'}
                        fontSize={isMobile ? '14px' : '18px'}
                        isInvalid={!!errors.phone}
                        errormessage={!!errors.phone && errors.phone.message}
                        {...register('phone', {
                            required: 'Phone is required',
                        })}
                        maxW={'565px'}/>
                </HStack>
                <InputLabel
                    label={'Telegram'}
                    height={isMobile ? '40px' : '52px'}
                    fontSize={isMobile ? '14px' : '18px'}
                    isInvalid={!!errors.telegram}
                    errormessage={!!errors.telegram && errors.telegram.message}
                    {...register('telegram', {
                        required: 'Telegram is required',
                    })}
                    placeholder={'Telegram Nickname'}
                    maxW={'565px'}
                    leftAddon={<TelegramIcon width={isMobile ? '20px' : '26px'}/>}/>
                <InputLabel
                    label={'Password'}
                    fontSize={isMobile ? '14px' : '18px'}
                    height={isMobile ? '40px' : '56px'}
                    isInvalid={!!errors.password}
                    errormessage={!!errors.password && errors.password.message}
                    {...register('password', {
                        required: 'Password is required',
                        minLength: {
                            value: 8,
                            message: 'Password must be at least 8 characters',
                        },
                        pattern: {
                            value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
                            message: 'Password must contain letters and numbers',
                        },
                    })}
                    type={showPassword ? "text" : "password"}
                    rightAddon={<EyeIcon onClick={togglePassword} width={isMobile ? '20px' : '26px'}/>}
                    placeholder={'Password'}
                    maxW={'565px'}
                    leftAddon={<LockIcon width={isMobile ? '20px' : '26px'}/>}/>
                <InputLabel
                    label={'Repeat Password'}
                    fontSize={isMobile ? '14px' : '18px'}
                    height={isMobile ? '40px' : '52px'}
                    errormessage={!!errors.repeatPassword  && errors.repeatPassword.message}
                    isInvalid={!!errors.repeatPassword}
                    {...register('repeatPassword', {
                        required: 'Repeat Password',
                        validate: (value) =>
                            value === password || 'Passwords do not match',
                    })}
                    type={showPassword ? "text" : "password"}
                    rightAddon={<EyeIcon onClick={togglePassword} width={isMobile ? '20px' : '26px'}/>}
                    placeholder={'Repeat Password'}
                    maxW={'565px'}
                    leftAddon={<LockIcon width={isMobile ? '20px' : '26px'}/>}/>
                <Box>
                    <HStack mb={'6px'}>
                        <BadgeIcon/>
                        <Text color={'neutral.400'} fontSize={'body.sm'}>
                            Promocode
                        </Text>
                    </HStack>
                    <InputLabel
                        fontSize={isMobile ? '14px' : '18px'}
                        height={isMobile ? '40px' : '52px'}
                        errormessage={!!errors.promocode && errors.promocode.message}
                        isInvalid={!!errors.promocode}
                        {...register('promocode', {
                            required: false,
                        })}
                        rightAddon={<CopyIcon onClick={copyPromocode} width={isMobile ? '20px' : '26px'}/>}
                        placeholder={'Promocode'}
                        maxW={'322px'}
                    />
                </Box>
                <Text  color={'#FFFFFFB2'} fontSize={isMobile ? 'body.sm':'body.md'}>Have an account? <Text as={Link} to={'/auth/login'} fontWeight={'bold'}>Sign
                    in now!</Text></Text>
                <HStack>
                    <CustomCheckbox {...register('terms', {required: true})}/>
                    <Text fontSize={isMobile ? 'body.xs':'body.sm'} color={'#FFFFFFB2'}>I have read and agree to
                        the <Text as={Link} to={'/auth/login'} textDecoration={'none !important'} color={'purple.500 !important'} fontWeight={'bold'}>User Agreement </Text>
                        & <Text as={Link} to={'/privacy'} color={'purple.500 !important'} textDecoration={'none !important'} fontWeight={'bold'}> Privacy Policy</Text>
                    </Text>
                </HStack>
                <StyledButton
                    disabled={!(isValid && isDirty)}
                    type={'submit'}
                    height={isMobile ? '40px' : '52px'}
                    fontSize={'body.lg'}
                    width={'full'}>
                    Sign up
                </StyledButton>
            </Flex>
        </form>
    )
}
